const abilities = {
	"Strength": 0,
	"Dexterity": 0,
	"Constitution": 0,
	"Intelligence": 0,
	"Wisdom": 0,
	"Charisma": 0,
};

const state = {
	key: "",
	scores: {
		base: {
			"Strength": 10,
			"Dexterity": 10,
			"Constitution": 10,
			"Intelligence": 10,
			"Wisdom": 10,
			"Charisma": 10,
		},
		race: {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
		theme: {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
		upgrades: {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
		temporary: {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
	},
	increases: {
		"5":{
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
		"10":{
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
		"15":{
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
		"20":{
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		},
	}
}

const getters = {
	base: (state) => {
		return state.scores.base
	},

	race: () => {
		return state.scores.race
	},

	theme: () => {
		return state.scores.theme
	},

	upgrades: () => {
		return state.scores.upgrades
	},

	temporary: () => {
		return state.scores.temporary
	},
	modifier: () => (abilityScore) => {
		return Math.floor((abilityScore - 10) / 2)
	},
	abilityIncreasesAtLevel: (state) => (level) => {
		var abilityIncreases = {
			"Strength": 0,
			"Dexterity": 0,
			"Constitution": 0,
			"Intelligence": 0,
			"Wisdom": 0,
			"Charisma": 0,
		}

		//Check to see if we have any Ability Increases from levelling, then add them in
		if(level >= 5){
			for( var i = 5; i <= level; i = i+5 ){
				for(const ability in abilityIncreases){
					abilityIncreases[ability] += state.increases[i][ability]
				}
			}
		}
		return abilityIncreases
	},
	abilityScoresAtLevel: (state, getters) => (level) => {
		var increases = getters.abilityIncreasesAtLevel(level)
		var result = Object.assign({}, abilities)

		for(const ability in result){
			result[ability] = 	state.scores.base[ability] +
								state.scores.race[ability] +
								state.scores.theme[ability] +
								state.scores.upgrades[ability] +
								state.scores.temporary[ability] +
								increases[ability]
		}
		return result
	},
	abilityModsAtLevel: (_state, getters) => (level) => {
		var abilityScores = getters.abilityScoresAtLevel(level)
		var mods = Object.assign({}, abilities)
		Object.keys(mods).forEach(function (key) {
			mods[key] = getters.modifier(abilityScores[key])
		});
		return mods
	},
	abilityScores: (state, getters, rootState, rootGetters) => {
		return getters.abilityScoresAtLevel( rootGetters.currentLevel )
	},
	abilityMods: (state, getters, rootState, rootGetters) => {
		return  getters.abilityModsAtLevel( rootGetters.currentLevel )
	},
	breakdown: (state) => {
		return state.scores
	},
	key: (state) => {
		return state.key
	}
}

const mutations = {
	setScores (state, payload) {
		state.scores.base = payload.Base
		state.scores.race = payload.Race
		state.scores.theme = payload.Theme
		state.scores.upgrades = payload.Upgrades
		state.scores.temporary = payload.Temporary
	},
	setScoresByBase (state, payload) {
		state.scores.base = payload
	},
	setScoresByRace (state, payload) {
		state.scores.race = payload
	},
	setScoresByTheme (state, payload) {
		state.scores.theme = payload
	},
	setScoresByUpgrades (state, payload) {
		state.scores.upgrades = payload
	},
	setScoresByTemporary (state, payload) {
		state.scores.temporary = payload
	},
	setIncreases (state, payload) {
		state.increases[payload.level] = payload.abilities
	},
	setKey (state, payload) {
		state.key = payload
	}
}

const actions = {
	loadCharacter ({ commit }, character) {
		commit('setScores', character.AbilityScores)
		commit('setKey',character.KeyAbility)
		for(var i = 5; i <= 20; i = i+5){
			if(character.Levels[i]){
				commit('setIncreases', {
					level: i, 
					abilities: character.Levels[i].AbilityIncreases
				})
			}
		}
	},
	updateScore ({ commit }, character) {
		commit('setCharacterProp', character)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}